module.exports = __webpack_public_path__ + "static/condo_currentApplication-d98128eebf0cb22bae7cc66f6a892d28.jpg";